import { Message } from 'rsuite';
import React from 'react';
import { Link } from 'react-router-dom';
import { settingsPortalSmtpAccountPath } from '../../routes/Paths';

const DisconnectedDescription = () => (
  <p>
    Email notification is temporarily paused due to some authentication issues.{' '}
    <Link to={settingsPortalSmtpAccountPath}>
      Please try reconnecting your SMTP account.
    </Link>
  </p>
);

const SmtpAccountDisconnectedMessage = () => (
  <Message
    type="warning"
    description={<DisconnectedDescription />}
    showIcon
    style={{ marginBottom: 16 }}
  />
);

export default SmtpAccountDisconnectedMessage;
